import FormattedMessage from 'I18n/components/FormattedMessage';

// Common lower tier message for starter cards
import { jsx as _jsx } from "react/jsx-runtime";
export const StarterLowerTierMessage = ({
  isFreePortal,
  loading
}) => {
  if (isFreePortal && !loading) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlus"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.starter.lowerTierPlus"
  });
};